import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useId, useRef } from "react";
import { ChatFrame } from "../../../components/Chat/frame";
import { Button } from "../../../components/base";
import { useUiTranslation } from "../../../i18n";
import { cn } from "../../../lib/utils";
const FOCUSABLE_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
const PANEL_SIZE_CLASS = {
    compact: "h-[min(560px,calc(100vh-84px))] w-[min(340px,calc(100vw-40px))]",
    default: "h-[min(680px,calc(100vh-84px))] w-[min(380px,calc(100vw-40px))]",
    expanded: "h-[min(760px,calc(100vh-84px))] w-[min(460px,calc(100vw-40px))]",
};
const renderSlot = (slot, props) => {
    if (!slot)
        return null;
    if (typeof slot === "function") {
        return slot(props);
    }
    return slot;
};
export const FloatingChatShell = ({ isOpen, panelId, title, newLabel, launcherLabel, closeLabel, size = "default", className, panelClassName, contentClassName, launcher, header, input, children, portalRoot, onNew, onOpenChange, }) => {
    const { t } = useUiTranslation();
    const generatedPanelId = useId();
    const resolvedPanelId = panelId ?? `floating-chat-shell-${generatedPanelId}`;
    const resolvedTitle = title ?? t("chat.title");
    const resolvedNewLabel = newLabel ?? t("chat.newChat");
    const resolvedLauncherLabel = launcherLabel ?? t("chat.open");
    const resolvedLauncherAriaLabel = resolvedLauncherLabel || t("chat.open");
    const resolvedCloseLabel = closeLabel ?? t("chat.close");
    const launcherHostRef = useRef(null);
    const previousOpenRef = useRef(isOpen);
    useEffect(() => {
        if (previousOpenRef.current && !isOpen) {
            launcherHostRef.current
                ?.querySelector(FOCUSABLE_SELECTOR)
                ?.focus();
        }
        previousOpenRef.current = isOpen;
    }, [isOpen]);
    const launcherSlotProps = {
        isOpen,
        label: resolvedLauncherLabel,
        ariaLabel: resolvedLauncherAriaLabel,
        ariaControls: resolvedPanelId,
        ariaExpanded: isOpen,
        onToggle: () => onOpenChange(!isOpen),
    };
    const renderedLauncher = renderSlot(launcher, launcherSlotProps);
    return (_jsx("div", { className: cn("pointer-events-auto flex items-end justify-end", className), children: isOpen ? (_jsx("section", { id: resolvedPanelId, role: "dialog", "aria-modal": false, "aria-label": resolvedTitle, className: cn("flex flex-col overflow-hidden rounded-2xl border bg-card text-card-foreground shadow-2xl", PANEL_SIZE_CLASS[size], panelClassName), children: _jsx(ChatFrame, { title: resolvedTitle, newLabel: resolvedNewLabel, closeLabel: resolvedCloseLabel, header: header, input: input, portalRoot: portalRoot, onNew: onNew, onClose: () => onOpenChange(false), contentClassName: contentClassName, className: "h-full", children: children }) })) : (_jsx("div", { ref: launcherHostRef, className: "contents", children: renderedLauncher ?? (_jsx(Button, { type: "button", size: "icon-lg", "aria-label": resolvedLauncherAriaLabel, "aria-controls": resolvedPanelId, "aria-expanded": false, title: resolvedLauncherAriaLabel, onClick: () => onOpenChange(true), className: cn("size-14 rounded-full shadow-[0_20px_40px_-18px_rgba(15,23,42,0.6)]", "font-semibold tracking-wide"), children: "AI" })) })) }));
};
//# sourceMappingURL=FloatingChatShell.js.map